import script from "./BPTQuestionsSortingForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./BPTQuestionsSortingForm.vue?vue&type=script&lang=ts&setup=true"

import "./BPTQuestionsSortingForm.vue?vue&type=style&index=0&id=724657ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-724657ec"]])

export default __exports__